'use client';
import React from 'react';
import Image from 'next/image';
import { FaFacebookF, FaTelegram } from 'react-icons/fa';
import { FaDiscord } from 'react-icons/fa6';

function Footer() {
  return (
    <div className="w-full bg-[#181623] pt-5">
      <div className="w-[1400px] max-xl:w-full py-3 px-3 m-auto bg-colorMain flex max-lg:flex-col max-lg:gap-y-2 justify-between items-center">
        <div className="flex gap-x-4 max-lg:flex-col items-center">
          <Image
            alt=""
            unoptimized={true}
            quality={100}
            src={'/images/icon.png'}
            width={134}
            height={33}
            className="h-[33px] cursor-pointer"
          />
          <div className="flex items-center max-lg:flex-col max-lg:gap-y-2 gap-x-4 cursor-pointer text-[12px] font-medium hover:text-yellowMain">
            <div className="text-white uppercase hover:text-yellowMain">Xem phim</div>
            <div className="text-white uppercase hover:text-yellowMain">
              Page Facebook
            </div>
            <div className="text-white uppercase hover:text-yellowMain">Thuật ngữ</div>
          </div>
        </div>
        <div className="flex gap-x-2 cursor-pointer">
          <div className="bg-slate-500 h-10 w-10 rounded-sm flex items-center justify-center group">
            <FaFacebookF className="text-[#f1ececf] text-[20px] group-hover:text-white" />
          </div>
          <a
            href="https://discord.gg/hT5k9gH3"
            target="_blank"
            className="bg-slate-500 h-10 w-10 rounded-sm flex items-center justify-center group"
          >
            <FaDiscord className="text-[#f1ececf] text-[20px] group-hover:text-white" />
          </a>
          <a
            href="https://t.me/+pNhByROOvbE4NDA1"
            target="_blank"
            className="bg-slate-500 h-10 w-10 rounded-sm flex items-center justify-center group"
          >
            <FaTelegram className="text-[#f1ececf] text-[20px] group-hover:text-white" />
          </a>
        </div>
      </div>
      <div className="w-[1400px] max-xl:w-full py-3 px-3 m-auto text-[13px] text-slate-500">
        <div className="text-center w-full">
          phim bộ trung quốc phim bộ hàn quốc phim mới phim lẻ anime mới anime vietsub
          anime hay sitemap Hayghe HaygheTv Tvhay Motchill Dongphim Bilutv Phimmoi
          Phimchill Vkool Vuighe Animevietsub Anime47 Animehay
        </div>
        <div className="text-center text-gray-400">
          Liên Hệ Quảng Cáo: accvip1901@gmail.com
        </div>
        <div className="text-center text-gray-400">
          © Copyright 2025 MEPHIM. All rights reserved.
        </div>
      </div>
    </div>
  );
}

export default Footer;
